import { CHOOSE_CAMPAIGN_COLUMNS, ExperimentsAction } from 'modules/experiments/types';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import { Campaign } from 'modules/domains/campaign';
import { CampaignResponse } from 'modules/experiments/takeover/types';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

type ChooseCampaignState = {
  isDrawerOpen: boolean;
  campaigns: Campaign[];
  loading: boolean;
  info: {
    count: number;
    limit: number;
    offset: number;
    page: number;
  };
  search: string;
  sortBy: CHOOSE_CAMPAIGN_COLUMNS;
  sortDirection: SORT_DIRECTIONS;
};

const chooseCampaignInitialState: ChooseCampaignState = {
  loading: false,
  isDrawerOpen: false,
  campaigns: [],
  info: {
    count: 0,
    limit: 10,
    offset: 0,
    page: 1,
  },
  search: '',
  sortBy: CHOOSE_CAMPAIGN_COLUMNS.LAST_MODIFIED,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
};

export const chooseCampaignReducer = (
  state = chooseCampaignInitialState,
  action: ExperimentsAction,
): ChooseCampaignState => {
  switch (action.type) {
    case ActionTypes.OPEN_CHOOSE_CAMPAIGN:
      return {
        ...state,
        loading: true,
        isDrawerOpen: true,
      };

    case ActionTypes.CLOSE_CHOOSE_CAMPAIGN:
      return {
        ...state,
        isDrawerOpen: false,
      };

    case ActionTypes.FETCH_CHOOSE_CAMPAIGN_RESPONSE: {
      const campaigns = (action?.payload?.results || []) as CampaignResponse['results'];
      const info = action?.payload?.info as CampaignResponse['info'];
      return {
        ...state,
        campaigns,
        info,
        loading: false,
      };
    }
    case ActionTypes.SET_CHOOSE_CAMPAIGN_PAGINATION_INFO: {
      const page = Number(action?.payload?.page);
      const pageSize = Number(action?.payload?.pageSize);

      return {
        ...state,
        loading: true,
        info: {
          ...state.info,
          limit: pageSize,
          offset: pageSize * (page - 1),
          page,
        },
      };
    }
    case ActionTypes.SET_CAMPAIGN_SEARCH: {
      return {
        ...state,
        loading: true,
        search: action.payload?.search as string,
      };
    }
    case ActionTypes.SET_CHOOSE_CAMPAIGN_SORT_BY: {
      return {
        ...state,
        loading: true,
        sortBy: action.payload?.sortBy as CHOOSE_CAMPAIGN_COLUMNS,
      };
    }
    case ActionTypes.SET_CHOOSE_CAMPAIGN_SORT_DIRECTION: {
      return {
        ...state,
        loading: true,
        sortDirection: action.payload?.sortDirection as SORT_DIRECTIONS,
      };
    }
    default:
      return state;
  }
};
